import React from 'react';

const Values = ({values, img_path}) => {

    const ValueItem = ({slide, i}) => {
        return <li className={'values_list_item'}>
            <picture>
                <source
                    srcSet={`${img_path}/icon_${slide.icon}.webp`}
                    type="image/webp"
                />
                <source
                    srcSet={`${img_path}/icon_${slide.icon}.png`}
                />
                <img
                    src={`${img_path}/icon_${slide.icon}.png`}
                    alt={`ColdWare ${slide.title}`}
                    width={96}
                    height={96}
                    className='slide_icon'
                />
            </picture>
            <div className={'img_wrapper'}>
                <picture>
                    <source
                        media="(min-width: 769px)"
                        srcSet={`${img_path}/value_${slide.img}.webp`}
                        type="image/webp"
                    />
                    <source
                        media="(min-width: 769px)"
                        srcSet={`${img_path}/value_${slide.img}.png`}
                    />
                    <img
                        src={`${img_path}/value_${slide.img}.png`}
                        alt={`ColdWare ${slide.title}`}
                        width={176}
                        height={723}
                        className='slide_img'
                    />
                </picture>
            </div>
            <h3 className={'slide_title'}>{slide.title}</h3>
            <p className={'slide_description'}>{slide.description}</p>
        </li>
    }

    return (
        <section className={'values_wrapper'}>
            <div className="container">
                <div className={'values_title'}>
                    <h2>{values.title}</h2>
                    {values.description ? <p>{values.description}</p> : null}
                </div>
            </div>
            <div className={'values'}>
                <ul className="container values_list">
                    {values.items.map((slide, i) => {
                        return <ValueItem
                            key={slide.key}
                            slide={slide}
                            i={i}
                        />
                    })}
                </ul>
            </div>
            <div className={'scroll_hide_wrapper'}>
                <div className={'scroll_hide'}>
                    <div className="container">
                        <div className="scroll_hide_inner"/>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Values;